import React from 'react'
import MainPage from "./MainPage"
import Signup from "./SignUp"
import SignIn from "./SignIn"
import Models from './Models';
import Tarification from "./Tarification";
import Init from './init';
import { BrowserRouter as Router, Switch, Route, Link } from 'react-router-dom';
import CV from './models/cv'
import CV2 from './models/cv2'
import CV3 from './models/cv3'
import Portforlio1 from './models/portfolio1';
import Portforlio2 from './models/portfolio2';
import About from './models/portfolio2_/about';
import Contact from './models/portfolio2_/contact';
import Work from './models/portfolio2_/work';
import Payment from './Payment';
import Profile from './Profile';
import Resulat1 from './models/Resultat1';

const ACCOUNT = '/account';
const ADMIN = '/admin';
const PASSWORD_FORGET = '/pw-forget';

export default class Routes extends React.Component{
render(){

    return(
        <Router>
 <Switch> {/* The Switch decides which component to show based on the current URL.*/}
      <Route exact path='/' component={MainPage}></Route>
      <Route exact path='/signup' component={Signup}></Route>
      <Route exact path='/signin' component={SignIn}></Route>
      <Route exact path='/tarification' component={Tarification}></Route>
      <Route exact path='/models' component={Models}></Route>
      <Route exact path='/models/create_cv1' component={CV}></Route>
      <Route exact path='/models/create_cv2' component={CV2}></Route>
      <Route exact path='/models/create_cv3' component={CV3}></Route>
      <Route exact path='/models/create_portfolio1' component={Portforlio1}></Route>
      <Route exact path='/models/create_portfolio2' component={Portforlio2}></Route>
      <Route exact path='/models/create_portfolio2/about' component={About}></Route>
      <Route exact path='/models/create_portfolio2/work' component={Work}></Route>
      <Route exact path='/models/create_portfolio2/contact' component={Contact}></Route>
      <Route exact path='/payment' component={Payment}></Route>
      <Route exact path='/profile' component={Profile}></Route>
<Route exact path='/models/create_cv1/result' component={Resulat1}></Route>
    </Switch>
        </Router>
       

    )
}


}